function initInfiniteScroll() {
  const loadMoreWrapper = document.querySelector('.js-load-more-wrapper');
  const blogContainer = document.querySelector('.js-blog-row');

  if (!loadMoreWrapper || !blogContainer) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loadMoreWrapper.classList.contains('loading')) {
        loadMoreWrapper.classList.add('loading');

        const url = loadMoreWrapper.dataset.url;
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newArticles = doc.querySelectorAll('.js-blog-row > *');
            newArticles.forEach(el => blogContainer.appendChild(el));

            const nextWrapper = doc.querySelector('.js-load-more-wrapper');
            if (nextWrapper) {
              loadMoreWrapper.dataset.url = nextWrapper.dataset.url;
              loadMoreWrapper.classList.remove('loading');
            } else {
              loadMoreWrapper.remove();
            }

            if (typeof initializeObservers === 'function') initializeObservers();
          });
      }
    });
  }, {
    rootMargin: '200px',
  });

  observer.observe(loadMoreWrapper);
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);

document.addEventListener("DOMContentLoaded", function () {
  const list = document.querySelector(".js-articles-counter");
  if (!list) return;

  const links = list.querySelectorAll(".js-article-tag");

  links.forEach(link => {
    const span = link.querySelector(".js-get-articles-counter");

    const url = link.getAttribute("href");
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const articles = doc.querySelector(".js-articles-counter");
        const count = articles.getAttribute("data-counter");

        if (span) {
          span.textContent = count;
        }
      })
      .catch(err => {
        console.warn("Błąd przy pobieraniu danych z " + url, err);
      });
  });
});